import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import styles from '../../common/customStylesRadioButton';
import { setAirport, showSidebar, resetFlights } from '../../../actions/bookingActions';
import _ from 'lodash';
import { AIRPORT_FROM, AIRPORT_TO } from 'components/utils/airportTypes';
import RevertAirportHelper from '../utils/RevertAirportHelper';
import T from 'components/common/translations/Translate';
import TransHelper from 'components/common/translations/TransHelper';

class BookingAirports extends React.Component {

  handleChangeInput = (item) => {
    const { setAirport, airportType } = this.props;

    var rah = new RevertAirportHelper(this.props, item, airportType);
    setAirport(rah.getAirportObject());

    //reset flights
    if (item.name !== this.props[airportType].label) {
      this.props.resetFlights();
    }
  }

  handleClickInput = () => {
    this.props.closeListAirports();
  }

  createId(item) {
    if (item.is_airport) {
      return "airport_" + this.parametrize(item.name);
    } else {
      return "city_" + this.parametrize(item.name);
    }
  }

  parametrize(value) {
    value = _.deburr(value);
    return _.snakeCase(value);
  }

  isChecked = (item) => {
    if (this.props.airportType === AIRPORT_TO) {
      var propsAirport = this.props.airportTo;
    } else {
      var propsAirport = this.props.airportFrom;
    }
    if (propsAirport) {
      //to prevent null compare
      if (!item.is_airport) {
        item.is_airport = false;
      }
      return propsAirport.isAirport === item.is_airport && propsAirport.id === item.id;
    } else {
      return false;
    }
  }

  processAirports = () => {
    const { airports, airportFrom, airportTo, airportType } = this.props;

    return airports;

    // //not selected any airport - initial state
    // if(airportFrom.id === null && airportTo.id === null){
    //   return airports;
    // }

    // //now is showing options for FROM input
    // if(airportType === AIRPORT_FROM){
    //   // if second input is an airport
    //   if(airportTo.id !== null && airportTo.isAirport){
    //     //so now show only cities
    //   }
    // }
  }

  render() {
    if (this.props.airports.length > 0) {
      return (
        <ul className="list-none list-radio">
          {
            this.processAirports().map(item => {
              var itemId = this.createId(item);
              return (
                <li key={_.uniqueId()}>
                  <label htmlFor={itemId}>
                    <div className="list-radio__label">{item.name}</div>
                    <div className="list-radio__input">
                      <Radio
                        id={itemId}
                        value={item.id}
                        checked={this.isChecked(item)}
                        onChange={() => this.handleChangeInput(item)}
                        onClick={this.handleClickInput}
                        classes={{
                          root: this.props.classes.root,
                          checked: this.props.classes.checked,
                        }}
                        name="aiports"
                      />
                    </div>
                  </label>
                </li>
              );
            })
          }
        </ul>
      );
    }

    return (
      <p style={{ padding: '20px' }}>
        {TransHelper.translate(
          this.props.locale,
          'content.bookingStep1.chooseAirport.listEmpty'
        )}
      </p>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    airportFrom: state.booking.airportFrom,
    airportTo: state.booking.airportTo
  };
};

export default connect(
  mapStateToProps, { setAirport, showSidebar, resetFlights }
)(withStyles(styles)(BookingAirports));
